export const TableImportList = [
  {
    id: 0,
    name: "Prénom légal"
  },
  {
    id: 1,
    name: "Nom légal"
  },
  {
    id: 2,
    name: "Courriel de correspondance"
  },
  {
    id: 3,
    name: "Genre légal"
  },
  {
    id: 4,
    name: "Poste"
  },
  {
    id: 5,
    name: "Emplacement"
  },
  {
    id: 6,
    name: "Permission"
  },
  {
    id: 7,
    name: "Supérieur hierarchique"
  },
  {
    id: 8,
    name: "Groupe"
  },
  {
    id: 9,
    name: "Date d'embauche"
  },
  {
    id: 10,
    name: "Date d'anniversaire"
  },
  {
    id: 11,
    name: "Téléphone personnel"
  },
  {
    id: 12,
    name: "N de poste (personnel)"
  },
  {
    id: 13,
    name: "Adresse"
  },
  {
    id: 14,
    name: "Adresse complémentaire"
  },
  {
    id: 15,
    name: "Numéro d'employé"
  },
  {
    id: 16,
    name: "Prénom d'usage"
  },
  {
    id: 17,
    name: "Nom d'usage"
  },
  {
    id: 18,
    name: "Autre courriel"
  },
  {
    id: 19,
    name: "Téléphone professionnel"
  },
  {
    id: 20,
    name: "N de poste (professionnel)"
  },
  {
    id: 21,
    name: "Nom du 1er contact d'urgence"
  },
  {
    id: 22,
    name: "Téléphone du 1er contact d'urgence"
  },
  {
    id: 23,
    name: "Courriel du 1er contact d'urgence"
  },
  {
    id: 24,
    name: "Relation avec le 1er contact d'urgence"
  },
  {
    id: 25,
    name: "Nom du 2nd contact d'urgence"
  },
  {
    id: 26,
    name: "Téléphone du 2nd contact d'urgence"
  },
  {
    id: 27,
    name: "Courriel du 2nd contact d'urgence"
  },
  {
    id: 28,
    name: "Relation avec le 2nd contact d'urgence"
  },
  {
    id: 29,
    name: "Numéro d’assurance social"
  },
  {
    id: 30,
    name: "Numéro de transit"
  },
  {
    id: 31,
    name: "Numéro d’institution"
  },
  {
    id: 32,
    name: "Numéro de compte"
  }
];